
const currenturl = () => {

	const url = location.protocol + "//" + location.host + location.pathname;
	$("a[href='"+url+"']").addClass('current');
	$("a[href='"+ url.replace(/\/$/, "") +"']").addClass('current');

	const path = location.pathname;
	$("a[href='"+path+"']").addClass('current');
	$("a[href='"+ path.replace(/\/$/, "") +"']").addClass('current');

}

export { currenturl }